var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#151D26",
    d: "M1.787 14.934v-6.57H0V6h1.787V3.98C1.787 2.39 2.842.934 5.274.934c.985 0 1.713.091 1.713.091l-.057 2.21s-.743-.008-1.553-.008c-.877 0-1.018.393-1.018 1.045V6H7l-.114 2.365H4.359v6.57z"
  })));
};
export default SvgFacebook;